import type { ReactNode } from 'react';

export function ChapterTitle(props: { children: ReactNode; className?: string }) {
    return <h2 className={props.className || ''}>{props.children}</h2>;
}
